import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { showMenu } from 'react-contextmenu/modules/actions';

import IconMore from '../svg/IconMore';

function More({ id, size, onClick, className, style }) {
  const el = useRef();

  const showContextMenu = () => {
    onClick();
    const p = el.current.getBoundingClientRect();
    showMenu({
      position: {x: p.left, y: p.top + p.height},
      target: {},
      id: `DynamicMenu`
    })
  }

  return (
    <div ref={el} id={id} className={className} style={{...style}} onClick={showContextMenu} >
      <IconMore size={size} />
    </div>
  )
}

More.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default More;
